const MANAGE_TOKEN_KEY = "manageToken";
const MANAGE_USER_KEY = "manageUser";
const MANAGE_LAST_ACTIVE_KEY = "manageLastActive";
const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes of continuous idle time while open

function safeParse(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function touchManageActivity() {
  if (typeof window === "undefined") return;
  localStorage.setItem(MANAGE_LAST_ACTIVE_KEY, String(Date.now()));
}

export function saveManageSession(session) {
  if (typeof window === "undefined") return;
  if (!session?.token) return;
  localStorage.setItem(MANAGE_TOKEN_KEY, session.token);
  localStorage.setItem(MANAGE_USER_KEY, JSON.stringify(session));
  touchManageActivity();
}

export function loadManageSession() {
  if (typeof window === "undefined") return { token: null, user: null };
  
  const token = localStorage.getItem(MANAGE_TOKEN_KEY);
  const user = safeParse(localStorage.getItem(MANAGE_USER_KEY));

  if (!token) return { token: null, user: null };

  const lastActiveStr = localStorage.getItem(MANAGE_LAST_ACTIVE_KEY);
  const now = Date.now();

  if (lastActiveStr) {
    const lastActive = Number(lastActiveStr);
    // Auto sign-out only if tab was left open and idle with zero activity for > 30 minutes continuous
    if (Number.isFinite(lastActive) && now - lastActive > INACTIVITY_TIMEOUT_MS) {
      clearManageSession();
      return { token: null, user: null };
    }
  }

  // Refresh activity timestamp on navigation / active page usage
  touchManageActivity();

  return { token, user };
}

export function clearManageSession() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(MANAGE_TOKEN_KEY);
  localStorage.removeItem(MANAGE_USER_KEY);
  localStorage.removeItem(MANAGE_LAST_ACTIVE_KEY);
}

export async function manageFetch(url, options = {}) {
  const { token: manageToken } = loadManageSession();
  const fallbackToken =
    typeof window !== "undefined"
      ? localStorage.getItem("authToken") || localStorage.getItem("token")
      : null;
  const token = manageToken || fallbackToken;

  if (token) {
    touchManageActivity();
  }

  const headers = {
    ...(options.headers || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(url, {
    ...options,
    headers,
  });
  if (response.status === 401) {
    clearManageSession();
  }
  return response;
}

// Activity Event Listeners for 30-minute idle detection while on page
if (typeof window !== "undefined") {
  const activityEvents = ["mousemove", "keydown", "click", "scroll", "touchstart"];
  let throttleTimer = null;

  const handleUserActivity = () => {
    if (!throttleTimer) {
      const { token } = loadManageSession();
      if (token) {
        touchManageActivity();
      }
      throttleTimer = setTimeout(() => {
        throttleTimer = null;
      }, 5000);
    }
  };

  activityEvents.forEach((event) => {
    window.addEventListener(event, handleUserActivity, { passive: true });
  });
}
